<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <popup-header v-on:clickClose="closeModal()" />
      <hol-replace-period-select-date-header />
      <select-date-title-hol-replace
        :activeTab="activeTab"
      ></select-date-title-hol-replace>
      <select-date-content-hol-replace-period
        @selectDate="selectDate"
      ></select-date-content-hol-replace-period>
    </div>
  </v-dialog>
</template>
<script>
import PopupHeader from '@/components/common/PopupHeader.vue';
import HolReplacePeriodSelectDateHeader from '@/components/application/form/HolReplacePeriodSelectDateHeader.vue';
import SelectDateContentHolReplacePeriod from '@/components/application/form/SelectDateContentHolReplacePeriod.vue';
import SelectDateTitleHolReplace from '@/components/application/form/SelectDateTitleHolReplace.vue';

//import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
//import applCode from '@/const/applCodeConstants';

export default {
  mixins: [applCdMixin, dialogMixin],
  components: {
    HolReplacePeriodSelectDateHeader,
    SelectDateContentHolReplacePeriod,
    SelectDateTitleHolReplace,
    PopupHeader,
  },
  data: () => ({
    modalName: 'date_hol_replace_app',
    activeTab: 'E',
    type: '',
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_E_YMD']),
    ...mapGetters([
      'GET_APPL_CD',
      'GET_RETURNYMD',
      'GET_APPL_TYPE',
      'GET_HOL_REPLACE_PERIOD_DATA',
      'GET_WORK_TYPE_CD',
    ]),
  },
  methods: {
    async selectDate(date, validResult) {
      if (validResult) {
        this.$parent.replaceYmd = dayjs(date).format('YYYY-MM-DD');
      } else {
        this.$parent.replaceYmd = '';
      }

      if (
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '03' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '04' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '08' ||
        this.GET_HOL_REPLACE_PERIOD_DATA.getBfTimeGb === '13'
      ) {
        this.$parent.vShow = false;
      } else {
        this.$parent.vShow = true;
      }

      // 전일, 반일
      if (this.GET_WORK_TYPE_CD === 'A') {
        this.$parent.vShowReplace = false;
      } else {
        this.$parent.vShowReplace = true;
      }

      this.closeModal();
      this.OFF_APP_SPINNER();
    },
  },
  mounted() {},
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
